"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectField = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const SelectFieldBase_1 = require("./internal/SelectFieldBase");
function SelectField(props) {
    const { getOptionValue = (opt) => opt.id, // if unset, assume O implements HasId
    getOptionLabel = (opt) => opt.name, // if unset, assume O implements HasName
    options, onSelect, value, ...otherProps } = props;
    return ((0, jsx_runtime_1.jsx)(SelectFieldBase_1.SelectFieldBase, { ...otherProps, options: options, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, values: [value], onSelect: (values, options) => {
            if (values.length > 0 && options.length > 0) {
                const option = options[0];
                onSelect(values[0], option === SelectFieldBase_1.unsetOption ? undefined : option);
            }
        } }));
}
exports.SelectField = SelectField;
